import React from 'react';

import Paragraph from '@/components/Paragraph';
import { ImageType } from '@/components/Image';
import useTranslations from '@/hooks/useTranslations';
import { QuickFAQ } from '@/types/ContactBlock';

import GenericBlock from './GenericBlock';
import QuickFaqs from './QuickFaqs';

type Props = {
  title: string;
  image: ImageType;
  faqs: QuickFAQ[];
  locale: string;
};

const QuickAnswerBlock: React.FC<Props> = (props) => {
  const { title, image, faqs, locale } = props;

  const { t } = useTranslations('contact');

  return (
    <GenericBlock image={image} title={title}>
      {/* <Paragraph size='lg'>
        <ChatBotLink>{t('askChatBot')}</ChatBotLink>
        {`. ${t('availableAnytime')}.`}
      </Paragraph>
      <HorizontalSeparator /> */}
      <Paragraph size='lg'>{t('consultFaqs')}</Paragraph>
      <QuickFaqs faqs={faqs} locale={locale} />
    </GenericBlock>
  );
};

export default QuickAnswerBlock;
